import { TRACK_BANNER } from '@graphql/mutations/trackBanner'
import { useMutation } from '@apollo/react-hooks'

const trackBannerLead = async (id: string) => {
  const [trackBanner] = useMutation(TRACK_BANNER)
  await trackBanner({ variables: { id } })
}

export default trackBannerLead
